import * as React from 'react';
import classNames from 'classnames';
import style from './text-area.scss';
import {Flex} from '../Flex';
import {Text} from '../Text';

export interface TextAreaProps {
  label?: string;
  value: string;
  error?: string;
  helpText?: string;
  touched?: boolean;
}

type InputProps = JSX.IntrinsicElements['textarea'];

export function TextArea({
  id,
  label,
  value,
  error,
  touched = false,
  helpText,
  className,
  ...restProps
}: TextAreaProps & InputProps) {

  const showHelp = Boolean(helpText);
  const showError = Boolean(touched && error);
  const showLabel = Boolean(label);

  /* eslint-disable jsx-a11y/label-has-for */
  return (
    <Flex
      direction="column"
      className={classNames(style.wrap, className, {
        [style.error]: touched && error,
      })}
    >
      {showLabel && (
        <label className={style.label} htmlFor={id}>
          <Text text={String(label)} />
        </label>
      )}
      <textarea id={id} className={style.input} {...restProps} />
      {showError && <span className={style.error}>{error}</span>}
      {showHelp && <span className={style.help}>{helpText}</span>}
    </Flex>
  );
  /* eslint-enable */
}
